var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1709.93 303.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#cc8010;}.cls-3{fill:#242a40;}.cls-4{clip-path:url(#clippath-1);}.cls-5{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "221.78 43.49 44.66 43.49 44.66 192.31 113.43 184.35 131.25 173.94 138.65 170.6 175.58 172.94 198.89 147.85 236 131.17 221.78 43.49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.66,43.49h77.67l76.79,76.21,76.34-76.21h77.67v198.56h-94v-71.44l-60.01,59.54-60.46-59.54v71.44H44.66V43.49ZM100.26,218.23,297.51,218.23"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.83,
    y: 69.36,
    width: 215.02,
    height: 34.03,
    transform: "translate(30.39 -31.32) rotate(16.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.4,
    y: 113.09,
    width: 177.54,
    height: 33.79,
    transform: "translate(42.4 -24.71) rotate(16.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.62,
    y: 160.64,
    width: 172.42,
    height: 34.56,
    transform: "translate(56.27 -21.95) rotate(16.94)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.99,231.28c-16.79,0-33.37-1.45-48.19-5.2l9.15-36.16c27.87,7.05,74.89,4.6,125.77-6.56,55.9-12.25,82.56-36.87,116.3-68.04,3.03-2.8,6.11-5.64,9.25-8.51,41.25-37.73,103.52-61.33,162.5-61.59l.16,37.3c-59.9.27-110.3,26.94-137.49,51.82-3.1,2.83-6.13,5.63-9.12,8.39-34.89,32.22-67.84,62.65-133.62,77.07-22.78,4.99-59.22,11.48-94.71,11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.55,277.67c-16.79,0-33.37-1.45-48.2-5.2l9.15-36.16c27.87,7.06,74.89,4.6,125.77-6.55,55.9-12.25,82.56-36.87,116.31-68.04,3.03-2.8,6.11-5.64,9.25-8.51,41.25-37.73,103.52-61.33,162.5-61.59l.16,37.3c-59.9.27-110.3,26.94-137.49,51.82-3.1,2.83-6.13,5.63-9.11,8.39-34.89,32.22-67.84,62.65-133.62,77.07-22.78,5-59.22,11.48-94.71,11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.4,324.93c-16.79,0-33.37-1.45-48.19-5.2l9.15-36.16c27.87,7.05,74.88,4.6,125.77-6.55,55.9-12.26,82.56-36.88,116.31-68.05,3.03-2.8,6.1-5.64,9.24-8.51,41.25-37.73,103.52-61.33,162.5-61.59l.16,37.3c-59.9.27-110.3,26.94-137.49,51.82-3.09,2.83-6.12,5.63-9.11,8.39-34.89,32.22-67.84,62.66-133.63,77.08-22.78,5-59.22,11.48-94.71,11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.98,366.18c-16.79,0-33.37-1.45-48.19-5.2l9.15-36.16c27.87,7.05,74.89,4.6,125.77-6.55,55.9-12.25,82.56-36.87,116.3-68.04,3.03-2.8,6.11-5.64,9.25-8.51,41.25-37.73,103.51-61.33,162.5-61.59l.17,37.3c-59.9.27-110.3,26.94-137.49,51.82-3.1,2.83-6.13,5.63-9.12,8.39-34.89,32.22-67.84,62.65-133.62,77.07-22.78,5-59.22,11.48-94.71,11.48Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.38,129.83h-16.63V46.67h21.15l26.85,63.32,26.73-63.32h21.15v83.15h-16.63v-53.34l-22.92,53.34h-16.75l-22.92-53.57v53.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M544.82,44.89c26.01,0,45.5,17.46,45.5,43.48s-19.48,43.24-45.5,43.24-45.62-18.53-45.62-43.24,19.48-43.48,45.62-43.48ZM544.82,115.69c17.22,0,28.86-11.28,28.86-27.32s-11.64-27.56-28.86-27.56-28.99,11.17-28.99,27.56,12.12,27.32,28.99,27.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.78,46.67h16.63v33.86h45.5v-33.86h16.63v83.15h-16.63v-33.98h-45.5v33.98h-16.63V46.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M772.43,129.83v-55.48l-51.56,55.48h-13.42V46.67h16.63v55.12l51.67-55.12h13.31v83.15h-16.63Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M834.2,62h-29.46v-15.33h75.32v15.33h-29.22v67.83h-16.63V62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M936.72,44.89c26.01,0,45.5,17.46,45.5,43.48s-19.48,43.24-45.5,43.24-45.62-18.53-45.62-43.24,19.48-43.48,45.62-43.48ZM936.72,115.69c17.22,0,28.86-11.28,28.86-27.32s-11.64-27.56-28.86-27.56-28.99,11.17-28.99,27.56,12.12,27.32,28.99,27.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M999.68,46.67h42.53c17.82,0,32.79,11.76,32.79,29.46,0,16.75-15.8,29.46-32.79,29.46h-25.89v24.23h-16.63V46.67ZM1042.21,62h-25.89v28.03h25.89c9.15,0,16.16-6.06,16.16-13.9s-6.89-14.13-16.16-14.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1157.56,129.83v-55.48l-51.56,55.48h-13.42V46.67h16.63v55.12l51.67-55.12h13.31v83.15h-16.63Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1195.1,46.67h16.63v33.86h45.5v-33.86h16.63v83.15h-16.63v-33.98h-45.5v33.98h-16.63V46.67Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1352.51,46.67v14.49h-41.1v68.66h-16.63V46.67h57.73Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M451.06,242.52v-55.48l-51.56,55.48h-13.42v-83.15h16.63v55.12l51.67-55.12h13.31v83.15h-16.63Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M581.97,159.37v14.49h-41.1v68.66h-16.63v-83.15h57.73Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M664.54,242.52v-55.48l-51.56,55.48h-13.42v-83.15h16.63v55.12l51.67-55.12h13.31v83.15h-16.63Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M706,227.08c6.3-10.57,9.38-22.93,9.38-36.83v-30.89h60.59v67.71h10.45v34.45h-16.63v-19.01h-56.31v19.01h-16.63v-34.45h9.15ZM759.33,227.08v-52.39h-27.32v15.92c0,13.3-2.85,25.3-8.79,36.47h36.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M802.1,159.37h42.53c17.82,0,32.79,11.76,32.79,29.46,0,16.75-15.8,29.46-32.79,29.46h-25.89v24.23h-16.63v-83.15ZM844.63,174.7h-25.89v28.03h25.89c9.15,0,16.16-6.06,16.16-13.9s-6.89-14.13-16.16-14.13Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M936.94,157.59c26.01,0,45.5,17.46,45.5,43.48s-19.48,43.24-45.5,43.24-45.62-18.53-45.62-43.24,19.48-43.48,45.62-43.48ZM936.94,228.39c17.22,0,28.86-11.28,28.86-27.32s-11.64-27.56-28.86-27.56-28.99,11.17-28.99,27.56,12.12,27.32,28.99,27.32Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1022.83,174.7h-29.46v-15.33h75.32v15.33h-29.22v67.83h-16.63v-67.83Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1084.72,159.37h68.66v15.33h-52.03v18.53h50.13v15.32h-50.13v18.53h52.03v15.44h-68.66v-83.15Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1259.11,242.52h-21.62l-24.47-29.22-24.47,29.22h-21.62l35.28-42.17-34.33-40.98h21.62l23.52,28.03,23.52-28.03h21.62l-34.33,40.98,35.28,42.17Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1272.65,159.37h16.63v33.86h45.5v-33.86h16.63v83.15h-16.63v-33.98h-45.5v33.98h-16.63v-83.15Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1437.3,242.52v-55.48l-51.56,55.48h-13.42v-83.15h16.63v55.12l51.67-55.12h13.31v83.15h-16.63Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1491.48,242.52h-16.63v-83.15h16.63v33.97h9.5l32.43-33.97h22.57l-39.44,41.57,42.53,41.58h-23.17l-35.28-33.98h-9.15v33.98Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1604.8,159.37h18.53l41.93,83.15h-18.53l-9.86-19.6h-45.5l-9.86,19.6h-18.42l41.7-83.15ZM1629.16,207.72l-15.09-29.94-15.09,29.94h30.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMig);
export default __webpack_public_path__ + "static/media/LogoMig.611c196a27532948433db796f957c9e8.svg";
export { ForwardRef as ReactComponent };